import { FC, PropsWithChildren } from 'react';
import { ProjectCollectionResponse, ProjectStatuses } from '../../api/dtos';
import ProjectsContext from '../../contexts/data/ProjectsContext';
import useProjects from '../../hooks/data/useProjects';


export interface IProjectsProviderProps {
    initial?: ProjectCollectionResponse;
}

export const ProjectsProvider: FC<PropsWithChildren<IProjectsProviderProps>> = ({ initial, children }) => {
    const projects = useProjects({ revalidateOnFocus: false, fallbackData: initial});

    const contextData = {
        ...projects,
        data: projects.data?.filter(project => project.status == ProjectStatuses.ReleasedToMarket)
    }
    return (
        <ProjectsContext.Provider value={contextData}>
            {children}
        </ProjectsContext.Provider>
    );
}

//<IsLoading name="projects" loading={projects.loading} validating={projects.validating}/>
export default ProjectsProvider;
